export const ITEM_LIST_TITLE = `איך זה עובד?`;

export const TITLE = `אנו מבטיחים לכם שירות אישי, מקצועי ומהיר, עם דגש על שקיפות ואמינות. הגישו בקשה עוד היום והתקרבו צעד נוסף לבית שלכם.`;
